/**
 * 与客户端通信的公共方法
 */
var SCHEME = {
    /**
     * 点击关闭按钮事件
     */
    closeWebView() {
        var buttonNode = document.getElementById('embeddedButton');
        function goBack() {
            window.location = 'mhtm://webview/quit';
        }
        buttonNode.addEventListener('click', goBack);
        buttonNode.click();
        buttonNode.removeEventListener('click', goBack);
    },
    /**
     * 配置分享事件:基础分享
     */
    configBaseShare() {
        var buttonNode = document.getElementById('embeddedButton');
        function configShare() {
            var title = '木火通明八字',
                des = '专业好用的八字软件；支持手机和电脑使用；让易学数据世代相传。',
                url = 'https://' + location.hostname;
            var locationUrl = 'mhtm://webview/share?';
                locationUrl = locationUrl + 'title=' + title,
                locationUrl = locationUrl + '&des=' + des,
                locationUrl = locationUrl + '&url=' + url,
                locationUrl = locationUrl + '&icon=1';
                console.log('configBaseShare------', locationUrl)
            window.location = locationUrl;
        }
        buttonNode.addEventListener('click', configShare);
        buttonNode.click();
        buttonNode.removeEventListener('click', configShare);
    },
    /**
     * 配置分享事件:批盘分享
     * @param {批盘分享标题} pipanTitle 
     * @param {批盘分享Id} shareId 
     */
    configPiPanShare(pipanTitle, shareId) {
        console.log('configPiPanShare------', pipanTitle, shareId)
        var buttonNode = document.getElementById('embeddedButton');
        function configShare() {
            var des = '点击查看批盘内容。打开后可点击右上角『保存』将批盘内容保存到我的八字库中。';
            var url = 'https://' + location.hostname + '/share/comment/' + shareId;
            var locationUrl = 'mhtm://webview/share?';
                locationUrl = locationUrl + 'title=' + pipanTitle,
                locationUrl = locationUrl + '&des=' + des,
                locationUrl = locationUrl + '&url=' + url,
                locationUrl = locationUrl + '&icon=2';
                console.log('configPiPanShare------', locationUrl)
            window.location = locationUrl;
        }
        buttonNode.addEventListener('click', configShare);
        buttonNode.click();
        buttonNode.removeEventListener('click', configShare);
    },
    /**
     * 配置分享事件:论盘分享
     * @param {论盘分享标题} lunpanTitle 
     * @param {论盘分享Id} shareId 
     */
    configLunPanShare(lunpanTitle, shareId) {
        console.log('configLunPanShare------', lunpanTitle, shareId)
        var buttonNode = document.getElementById('embeddedButton');
        function configShare() {
            var des = '点击进入在线论盘，论盘记录将永久保存在对应八字下面的论盘记录中，可随时查阅。';
            var url = 'https://' + location.hostname + '/share/discuss/' + shareId;
            var locationUrl = 'mhtm://webview/share?';
                locationUrl = locationUrl + 'title=' + lunpanTitle,
                locationUrl = locationUrl + '&des=' + des,
                locationUrl = locationUrl + '&url=' + url,
                locationUrl = locationUrl + '&icon=3';
                console.log('configLunPanShare------', locationUrl)
            window.location = locationUrl;
        }
        buttonNode.addEventListener('click', configShare);
        buttonNode.click();
        buttonNode.removeEventListener('click', configShare);
    },
    /**
     * 测评页面:请求支付
     * @param {产品id} productId 
     * @param {八字id} detailId 
     */
    createAppOrder(productId, detailId) {
        console.log('createAppOrder-------', productId, detailId)
        var buttonNode = document.getElementById('embeddedButton');
        function createOrder() {
            var locationUrl = 'mhtm://webview/pay?';
                locationUrl = locationUrl + 'pid=' + productId;
                locationUrl = locationUrl + '&bzid=' + detailId;
            window.location = locationUrl;
        }
        buttonNode.addEventListener('click', createOrder);
        buttonNode.click();
        buttonNode.removeEventListener('click', createOrder);
    },
    /**
     * 保存下单的标签信息
     * @param {标签id} labelId 
     * @param {标签文本} labelStr 
     * @param {备注文本} remark 
     */
    saveSelectLabel(labelId, labelStr, remark) {
        console.log('saveSelectLabel-------', labelId, labelStr, remark)
        var buttonNode = document.getElementById('embeddedButton');
        function saveLabel() {
            var locationUrl = 'mhtm://webview/selectlabel?';
                locationUrl = locationUrl + 'id=' + labelId;
                locationUrl = locationUrl + '&str=' + labelStr;
                locationUrl = locationUrl + '&remark=' + remark;
            window.location = locationUrl;
        }
        buttonNode.addEventListener('click', saveLabel);
        buttonNode.click();
        buttonNode.removeEventListener('click', saveLabel);
    },
    /**
     * 保存编辑的标签信息
     * @param {标签id} labelId 
     * @param {标签文本} labelStr 
     * @param {备注文本} remark 
     */
    saveUpdateLabel(labelId, labelStr, remark) {
        console.log('saveUpdateLabel-------', labelId, labelStr, remark)
        var buttonNode = document.getElementById('embeddedButton');
        function saveLabel() {
            var locationUrl = 'mhtm://webview/updatelabel?';
                locationUrl = locationUrl + 'id=' + labelId;
                locationUrl = locationUrl + '&str=' + labelStr;
                locationUrl = locationUrl + '&remark=' + remark;
            window.location = locationUrl;
        }
        buttonNode.addEventListener('click', saveLabel);
        buttonNode.click();
        buttonNode.removeEventListener('click', saveLabel);
    },
    /**
     * 保存搜索的标签信息
     * @param {标签id} labelId 
     * @param {标签文本} labelStr 
     * @param {标签短文本} shortStr 
     */
    saveSearchLabel(labelId, labelStr, shortStr) {
        console.log('saveSearchLabel-------', labelId, labelStr, shortStr)
        var buttonNode = document.getElementById('embeddedButton');
        function saveLabel() {
            var locationUrl = 'mhtm://webview/searchlabel?';
                locationUrl = locationUrl + 'id=' + labelId;
                locationUrl = locationUrl + '&str=' + labelStr;
                locationUrl = locationUrl + '&short=' + shortStr;
            window.location = locationUrl;
        }
        buttonNode.addEventListener('click', saveLabel);
        buttonNode.click();
        buttonNode.removeEventListener('click', saveLabel);
    }
}

export {
    SCHEME
}